// Function settings
let modularscale = {
    base: 16,
    ratio: 1.5,
};

// Function
function msFunction(v,settings) {

    // Parse settings
    // Write initial settings if undefined
    if (settings === undefined) {
        settings = modularscale;
    }
    // Initiate values
    let base = settings.base;
    let ratio = settings.ratio;
    // Fill in the blanks with default values
    if (ratio === undefined) {
        ratio = modularscale.ratio;
    }
    if (base === undefined) {
        base = modularscale.base;
    }

    // Fast calc if not multi stranded
    if (!Array.isArray(base) || base.length === 1) {
        return (Math.pow(ratio,v) * base);
    }

    // Normalize bases
    // Find the upper bounds for base values
    let baseHigh = Math.pow(ratio,1) * base[0];
    for (let i = 1; i < base.length; i++) {
        // shift up if value too low
        while (base[i]/1 < base[0]/1) {
            base[i] = Math.pow(ratio,1) * base[i];
        }
        // Shift down if too high
        while (base[i]/1 >= baseHigh/1) {
            base[i] = Math.pow(ratio,-1) * base[i];
        }
    }
    // Sort bases
    base.sort();

    // Figure out what base to use with modulo
    let rBase = Math.round((v / base.length - Math.floor(v/base.length)) * base.length);

    // Return
    return Math.pow(ratio,Math.floor(v/base.length)) * base[rBase];
};

const ms = (v,settings) => {
    return msFunction(v,settings);
};

export default ms;



// WEBPACK FOOTER //
// ./src/helper/modularScale.js